import { useGetAlterationRequests } from "@entities/financeApproval/lib/hooks/useGetAlterationRequests";
import { BriefCampaignInf } from "@shared/lib/types/briefCampains";
import { List, Typography } from "antd";
import React, { useState } from "react";
import { AlterationHistoryItemCard } from "./AlterationHistoryItemCard";

interface CampaignAlterationHistoryProps {
  campaignInfluencerId?: string;
  briefId?: string;
  campaignInfluencer?: BriefCampaignInf;
}

export const CampaignAlterationHistory: React.FC<CampaignAlterationHistoryProps> = ({
  campaignInfluencerId,
  briefId,
  campaignInfluencer,
}) => {
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const { alterations, totalCount, isFetching } = useGetAlterationRequests(
    {
      searchQuery: "",
      status: [],
      limit: pageSize,
      pageNo,
      campaignInfluencerIds: campaignInfluencerId ? [campaignInfluencerId] : [],
    },
    !!campaignInfluencerId
  );

  return (
    <List
      loading={isFetching}
      dataSource={alterations}
      locale={{
        emptyText: (
          <Typography.Text type="secondary" style={{ fontSize: 12, fontStyle: "italic" }}>
            No alteration request history found.
          </Typography.Text>
        ),
      }}
      pagination={
        totalCount > pageSize
          ? {
              current: pageNo,
              pageSize: pageSize,
              total: totalCount,
              size: "small",
              onChange: (page, pSize) => {
                setPageNo(page);
                if (pSize) setPageSize(pSize);
              },
            }
          : false
      }
      renderItem={(alterationItem) => (
        <List.Item style={{ padding: "6px 0", borderBottom: "none" }}>
          <AlterationHistoryItemCard
            alterationItem={alterationItem}
            briefId={briefId}
            campaignInfluencer={campaignInfluencer}
          />
        </List.Item>
      )}
      style={{
        maxHeight: 300,
        overflowY: "auto"
      }}
    />
  );
};
